import { BOT_USER_ID } from 'constants/UserConstants';

/**
 * Calculate initials from user object
 * @param {Object} user - User object with name, email, and/or initials
 * @returns {string} Two-letter initials or null
 */
export function calculateInitials(user) {
  if (!user) return null;

  // If user already has initials, use them
  if (user.initials) {
    return user.initials;
  }

  // Special case for bot user
  if (user.id === BOT_USER_ID) {
    return 'AI';
  }
  
  // Try to get initials from name
  if (user.name && user.name.length > 0) {
    const nameArray = user.name.split(' ');
    const firstLetter = nameArray[0] ? nameArray[0][0] : "";
    const secondLetter = nameArray[1] ? nameArray[1][0] : "";
    return firstLetter + secondLetter;
  }
  
  // Fall back to first letter of email
  if (user.email) {
    return user.email[0].toUpperCase();
  }
  
  return null;
}

/**
 * Enhance user object with calculated initials
 * @param {Object} user - User object
 * @returns {Object} User object with initials property
 */
export function userWithInitials(user) {
  if (!user) return null;
  
  return {
    ...user,
    initials: calculateInitials(user)
  };
}